import i18n from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(resourcesToBackend((lng: string) => import(`./locales/${lng}.json`)))
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    saveMissing: true,
    missingKeyHandler: function (lng, ns, key, fallbackValue) {
      if (!i18n.isInitialized) {
        return;
      }
      console.warn('Missing translation key:', { lng, ns, key, fallbackValue });
    },
  });

export default i18n;
